import React, { useEffect } from 'react';
import ProductPage from './Components/ProductPages/ProductPage';
import Bag from './Components/Bag/Bag';
import Checkout from './Components/Bag/Checkout';
import Accessories from './Components/Accessories';
import Clothing from './Components/Clothing';
import Shoes from './Components/Shoes';
import MainPage from './Components/MainPage';
import Items from './Components/Items';
import ScrollToTop from './Components/ScrollToTop';

import { Routes, Route } from 'react-router-dom';

//data
import productsData from './productsData';
import PageNotFound from './Components/PageNotFound';
import Lenis from 'lenis';

function App() {
    useEffect(() => {
        const lenis = new Lenis();
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
    }, []);

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path='/' exact element={<MainPage />} />
                <Route path='*' element={<PageNotFound />} />
                {/* <Route path='/mainPage' element={<MainPage />} />*/}
                <Route path='/clothing' exact element={<Clothing />} />
                <Route path='/accessories' exact element={<Accessories />} />
                <Route path='/shoes' exact element={<Shoes />} />
                <Route path='/items' exact element={<Items />} />

                <Route path='/bag' exact element={<Bag />} />
                <Route path='/checkout' exact element={<Checkout />} />

                {productsData.clothing.map((product) => (
                    <Route
                        key={product.productId}
                        path={`product/${product.productId}/${product.productName}`}
                        exact
                        element={
                            <ProductPage
                                productName={product.productName}
                                productPrice={product.productPrice}
                                productId={product.productId}
                                productCategory='Clothing'
                                image1={product.image}
                                image2={product.image2}
                                image3={product.image3}
                                image4={product.image4}
                                image5={product.image5}
                                productDescription={product.productDescription}
                                renderSuggested={true}
                                size='Clothing'
                                link={`product/${product.productId.toLowerCase()}/${product.productName.toUpperCase()}`}
                            />
                        }
                    />
                ))}

                {productsData.accessories.map((product) => (
                    <Route
                        key={product.productId}
                        path={`product/${product.productId}/${product.productName}`}
                        exact
                        element={
                            <ProductPage
                                productName={product.productName}
                                productPrice={product.productPrice}
                                productId={product.productId}
                                productCategory='Accessories'
                                image1={product.image}
                                image2={product.image2}
                                image3={product.image3}
                                image4={product.image4}
                                image5={product.image5}
                                productDescription={product.productDescription}
                                renderSuggested={false}
                                size='One'
                                link={`product/${product.productId.toLowerCase()}/${product.productName.toUpperCase()}`}
                            />
                        }
                    />
                ))}

                {productsData.shoes.map((product) => (
                    <Route
                        key={product.productId}
                        path={`product/${product.productId}/${product.productName}`}
                        exact
                        element={
                            <ProductPage
                                productName={product.productName}
                                productPrice={product.productPrice}
                                productId={product.productId}
                                productCategory='Shoes'
                                image1={product.image}
                                image2={product.image2}
                                image3={product.image3}
                                image4={product.image4}
                                image5={product.image5}
                                productDescription={product.productDescription}
                                renderSuggested={true}
                                size='Shoes'
                                link={`product/${product.productId.toLowerCase()}/${product.productName.toUpperCase()}`}
                            />
                        }
                    />
                ))}
            </Routes>
        </>
    );
}

export default App;
